import { useState } from "react";
import { ChevronDown, ChevronUp, Percent } from "lucide-react";

const money = new Intl.NumberFormat("es-AR", {
  style: "currency",
  currency: "ARS",
  maximumFractionDigits: 2,
});

function roundedMoney(value) {
  return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
}

export function computedPercentageValue(field, sourceValue) {
  if (sourceValue?.status !== "calculated" || !sourceValue.summary) {
    return null;
  }
  const rate = Number(field.computedPercentage?.rate);
  const base = Number(sourceValue.summary.total);
  if (!Number.isFinite(rate) || !Number.isFinite(base)) return null;
  const outcomes = (sourceValue.summary.outcomes || []).map((outcome) => ({
    key: outcome.key,
    label: outcome.label,
    base: Number(outcome.total),
    amount: roundedMoney(Number(outcome.total) * rate / 100),
  }));
  return {
    sourceFieldId: field.computedPercentage.inputFieldId,
    rate,
    base,
    amount: outcomes.length
      ? roundedMoney(outcomes.reduce((sum, outcome) => sum + outcome.amount, 0))
      : roundedMoney(base * rate / 100),
    outcomes,
  };
}

export function WorkflowComputedPercentageField({ field, sourceValue }) {
  const [showBreakdown, setShowBreakdown] = useState(false);
  const value = computedPercentageValue(field, sourceValue);

  return (
    <section className="workflow-record-field workflow-percentage-field">
      <span className="workflow-record-label workflow-record-automated-label">
        <Percent size={13} />
        {field.label}{field.required && <strong> *</strong>}
      </span>
      <div className="workflow-record-calculated-control">
        <div className={`workflow-record-calculated-value${value ? " is-calculated" : ""}`}>
          <span>{value ? money.format(value.amount) : "Pendiente de cálculo"}</span>
          {value && <small>Calculado</small>}
        </div>
        {value && (
          <button
            className="workflow-record-calculated-action"
            type="button"
            aria-expanded={showBreakdown}
            aria-controls={`workflow-percentage-breakdown-${field.id}`}
            onClick={() => setShowBreakdown((current) => !current)}
          >
            {showBreakdown
              ? <ChevronUp size={15} />
              : <ChevronDown size={15} />}
            {showBreakdown ? "Ocultar desglose" : "Ver desglose"}
          </button>
        )}
      </div>

      {!value ? (
        <p className="workflow-percentage-pending">
          Se calculará automáticamente cuando termines el cálculo de intereses.
        </p>
      ) : showBreakdown && (
        <div
          className="workflow-percentage-breakdown"
          id={`workflow-percentage-breakdown-${field.id}`}
        >
          <header>
            <div>
              <small>Detalle del porcentaje</small>
              <strong>Cálculo del {value.rate}%</strong>
            </div>
            <span>
              {money.format(value.base)} × {value.rate}% ={" "}
              <strong>{money.format(value.amount)}</strong>
            </span>
          </header>
          <div className="workflow-percentage-result">
            {value.outcomes.map((outcome) => (
              <dl key={outcome.key}>
                <div>
                  <dt>{outcome.label}</dt>
                  <dd>{money.format(outcome.amount)}</dd>
                </div>
                <div>
                  <dt>Base actualizada</dt>
                  <dd>{money.format(outcome.base)}</dd>
                </div>
                <div>
                  <dt>Porcentaje aplicado</dt>
                  <dd>{value.rate}%</dd>
                </div>
                <div className="workflow-percentage-formula">
                  <dt>Operación</dt>
                  <dd>
                    {money.format(outcome.base)} × {value.rate}%
                  </dd>
                </div>
              </dl>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
